import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["data-testId"]
const _hoisted_2 = {
  key: 0,
  class: "tw-text-2xl"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Available Data Points", -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "tw-mt-1"
}
const _hoisted_7 = {
  key: 1,
  class: "tw-flex tw-justify-start tw-space-x-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioAccordion = _resolveComponent("StudioAccordion")!
  const _component_StudioCodeEditor = _resolveComponent("StudioCodeEditor")!
  const _component_TablerEdit = _resolveComponent("TablerEdit")!
  const _component_StudioButton = _resolveComponent("StudioButton")!

  return (_openBlock(), _createElementBlock("div", {
    "data-testId": `${_ctx.codeAreaKey}-code-editor-wrapper`,
    class: "tw-w-full"
  }, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["tw-mt-2 tw-w-3/4", _ctx.accordionIsExpanded ? 'tw-mb-8' : 'tw-mb-2'])
    }, [
      _createElementVNode("div", {
        innerHTML: _ctx.description,
        class: _normalizeClass(["tw-text-sm", _ctx.parametersDescription ? 'tw-mb-2' : 'tw-mb-4'])
      }, null, 10, _hoisted_3),
      (_ctx.parametersDescription)
        ? (_openBlock(), _createBlock(_component_StudioAccordion, {
            key: 0,
            isExpanded: _ctx.accordionIsExpanded,
            onOnToggleAccordion: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accordionIsExpanded = !_ctx.accordionIsExpanded))
          }, {
            head: _withCtx(() => [
              _hoisted_4
            ]),
            details: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: _ctx.parametersDescription,
                class: "tw-text-sm"
              }, null, 8, _hoisted_5)
            ]),
            _: 1
          }, 8, ["isExpanded"]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_StudioCodeEditor, {
      ref: _ctx.codeAreaKey,
      cmContainerId: 'cm_' + _ctx.codeAreaKey,
      doc: _ctx.doc,
      characterLimit: _ctx.characterLimit,
      addedExtensions: _ctx.getExtensionList(),
      useBasicSetup: true,
      language: _ctx.language,
      extraHtmlAttributes: _ctx.extraHtmlAttributes,
      onViewCreated: _ctx.handleViewCreated,
      onStateCreated: _ctx.handleStateCreated,
      onChange: _ctx.handleDocChange
    }, null, 8, ["cmContainerId", "doc", "characterLimit", "addedExtensions", "language", "extraHtmlAttributes", "onViewCreated", "onStateCreated", "onChange"]),
    (_ctx.shouldShowEditScriptCTA)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (!_ctx.editMode)
            ? (_openBlock(), _createBlock(_component_StudioButton, {
                key: 0,
                disabled: _ctx.editDisabled,
                trackingId: `edit-${_ctx.codeAreaKey}`,
                variant: "outline",
                onClick: _ctx.handleEdit
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_TablerEdit)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Edit ")
                ]),
                _: 1
              }, 8, ["disabled", "trackingId", "onClick"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_StudioButton, {
                  variant: "outline",
                  trackingId: `cancel-${_ctx.codeAreaKey}`,
                  onClick: _ctx.handleCancel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancel ")
                  ]),
                  _: 1
                }, 8, ["trackingId", "onClick"]),
                _createVNode(_component_StudioButton, {
                  loading: _ctx.saveLoading,
                  disabled: !_ctx.hasChanged || _ctx.saveLoading,
                  trackingId: `save-${_ctx.codeAreaKey}`,
                  onClick: _ctx.handleSave
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Save ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "trackingId", "onClick"])
              ]))
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}